import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _validationTypeToVali;
/**
 * Validates the day passed as string
 * @param value day as string for which we want to test the validation
 * @returns undefined if validation passes, else returns invalidation text for day
 */
export var dayValidator = function dayValidator(value) {
  if (!value) return; // because empty value is allowed, but not the wrong value
  var dayRegex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/;
  return dayRegex.test(value) ? undefined : 'Day is invalid';
};

/**
 * Validates the year passed as string
 * @param value year as string for which we want to test the validation
 * @returns undefined if validation passes, else returns invalidation text for year
 */
export var pubDateYearValidator = function pubDateYearValidator(value) {
  if (!value) return;
  var yearRegex = /^([1-9][0-9]{3})$/;
  return yearRegex.test(value) ? undefined : 'Year is invalid';
};
export var InputValidationName;

/** validation type to validation function mapping */
(function (InputValidationName) {
  InputValidationName["DAY"] = "day";
  InputValidationName["YEAR"] = "year";
})(InputValidationName || (InputValidationName = {}));
var validationTypeToValidatorMapper = (_validationTypeToVali = {}, _defineProperty(_validationTypeToVali, InputValidationName.DAY, dayValidator), _defineProperty(_validationTypeToVali, InputValidationName.YEAR, pubDateYearValidator), _validationTypeToVali);
export default validationTypeToValidatorMapper;